import Helper from "./url-helper.js"
import axios from 'axios'
import { ApiErrorCode } from "@/utils/error-codes";
import { shouldSkipErrorLoggingForInterceptor } from "@/utils/error-logging-adapter";
import logger from "@/utils/global-logger";

var urlConfig = Helper.fetchSiteConfig();

var isDev = process.env.NODE_ENV != "production";
var constructLocalDevDomain = (urlConfig) => urlConfig.protocol + "://" + urlConfig.siteName + "." + urlConfig.domain + ":8082";

var isLocalDev = (domain) => domain == "localcb.in"

function configureErrorInterceptor(axiosInstance) {
    axiosInstance.interceptors.response.use(
        function (response) { return response; },
        function (error) {
            if (axios.isAxiosError && axios.isAxiosError(error) && !shouldSkipErrorLoggingForInterceptor(error)) {
                var metadata = { service: 'chargebee-app' };
                if (error.config) {
                    if (error.config.baseURL) metadata.baseUrl = error.config.baseURL;
                    if (error.config.url) metadata.url = error.config.url;
                    if (error.config.method) metadata.method = error.config.method;
                }
                if (error.response) {
                    metadata.status = error.response.status;
                }
                logger.error(ApiErrorCode.API_REQUEST_FAILED, metadata, error);
            }
            return Promise.reject(error);
        }
    );
}

export default class RestClient {
    constructor() {
        this.axios = axios.create({
            baseURL: isDev ? constructLocalDevDomain(urlConfig) : urlConfig.origin,
            transformRequest: [(data, headers) => {
                if (headers["Content-Type"] == "application/x-www-form-urlencoded") {
                    var str = [];
                    for (var p in data) {
                        if (data.hasOwnProperty(p) && (!(data[p] == undefined || data[p] == null))) {
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
                        }
                    }
                    return str.join("&");
                } else {
                    return JSON.stringify(data);
                }
            }]
        });
        configureErrorInterceptor(this.axios);
    }

    get(args) {
        return this.axios.request(this._get.apply(this, arguments));
    }

    post(args) {
        return this.axios.request(this._post.apply(this, arguments));
    }

    _get(path, params, headers = {}) {
        var config = {
            method: "get",
            params: params,
            url: path,
            headers: Object.assign({
                'CbSource': 'viaHp'
            }, headers)
        }

        return config;
    }

    _post(path, data, headers = {}) {
        var config = {
            method: "post",
            data: data,
            url: path,
            headers: Object.assign({
                'Content-Type': 'application/x-www-form-urlencoded',
                'CbSource': 'viaHp'
            }, headers)
        }

        return config;
    }
}